export const isSubStrI = (fullString: string, subString: string) =>
	fullString.toLocaleLowerCase().includes(subString.toLocaleLowerCase());

export const URL_MATCH =
	/^https?:\/\/(?:www\.)?(?:(?:[-a-zA-Z0-9@:*%._+~#=]{1,256}[a-zA-Z0-9()]{1,6})|localhost)(?:[-a-zA-Z0-9()@:%_+.,~#?&*//=]*)$/;

export const MAPPING_CONTENT_COMP = /<UserAttributes/g;

const BASE64_MATCH = /^[A-Za-z0-9+/]+={0,2}$/;

export const isValidCertificate = (value: string): boolean => {
	if (!value) return false;

	// SAML (XML-DSig) carries the X.509 cert as base64-encoded DER; the PEM
	// armor is optional, so strip it and any whitespace before validating.
	const base64 = value
		.replace(/-----BEGIN CERTIFICATE-----/g, '')
		.replace(/-----END CERTIFICATE-----/g, '')
		.replace(/\s+/g, '');

	if (!base64 || base64.length % 4 !== 0 || !BASE64_MATCH.test(base64)) {
		return false;
	}

	// A DER-encoded X.509 certificate is an ASN.1 SEQUENCE (tag byte 0x30).
	return atob(base64).charCodeAt(0) === 0x30;
};
